import { mapImageObject } from '@/lib/formatProjectImages'
import { Project } from '@/types/project'
import { Box, Flex, Image, Link, Stack, Text } from '@chakra-ui/react'
import NextLink from 'next/link'
import * as React from 'react'
import { connectStateResults } from 'react-instantsearch-dom'

type Hit = Project & {
  objectID?: string
}

function Hits({ searchState, searchResults }: any) {
  const validQuery = searchState.query?.length >= 3
  const [results, setResults] = React.useState<any>([])

  React.useEffect(() => {
    if (!searchResults) return
    let resultsRaw = searchResults.hits.map((hit: Hit) => {
      if (typeof hit.images === 'string') {
        hit.images = mapImageObject(JSON.parse(hit.images))
      }
      return hit
    })
    setResults(resultsRaw)
  }, [searchResults])

  return (
    <Box>
      {searchResults?.hits.length === 0 && validQuery && (
        <Box>Aw snap! No search results were found.</Box>
      )}
      {searchResults?.hits.length > 0 && validQuery && (
        <Stack>
          {results.map(
            (hit: Hit) =>
              hit &&
              hit.published && (
                <Box
                  key={hit.objectID}
                  p={2}
                  _hover={{ backgroundColor: 'gray.100' }}
                  transitionDuration='300ms'
                  transitionProperty='all'>
                  <NextLink
                    href={`/nation/projects/${hit.slug}`}
                    passHref
                    legacyBehavior>
                    <Link>
                      <Flex align='center' gridGap={4}>
                        <Box
                          height={12}
                          flexBasis='25%'
                          backgroundColor='gray.100'>
                          {hit.images && hit.images.length > 0 && (
                            <Image
                              src={`${hit.images[0]?.pathImgkit}?tr=n-thumbnail`}
                              objectFit='cover'
                              objectPosition='center'
                              width='100%'
                              height='100%'
                              alt=''
                            />
                          )}
                        </Box>
                        <Text flexBasis='75%'>{hit.title}</Text>
                      </Flex>
                    </Link>
                  </NextLink>
                </Box>
              )
          )}
        </Stack>
      )}
    </Box>
  )
}

export default connectStateResults(Hits)
